import { BuildDesignWeightModalService } from './../build-design-weight-modal.service';
import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';

@Component({
  selector: 'build-design-weight-add-modal',
  templateUrl: './build-design-weight-add-modal.component.html'
})
export class BuildDesignWeightAddModalComponent {

  fields = this.buildDesignWeightService.getBuildDesignWeightFields();

  form: UntypedFormGroup = new UntypedFormGroup(this.getBuildDesignWeightFieldsValues(this.data || {}));

  constructor(
    private readonly buildDesignWeightService: BuildDesignWeightModalService,
    private readonly dialogRef: MatDialogRef<BuildDesignWeightAddModalComponent>,
    @Inject(MAT_DIALOG_DATA) private readonly data: { [field: string]: number }
  ) { }

  getBuildDesignWeightFieldsValues(data: any): { [key: string]: UntypedFormControl } {
    return this.buildDesignWeightService.getBuildDesignWeightFields()
      .reduce((obj: any, { field }: { field: string, name: string }) => ({ ...obj, [field]: new UntypedFormControl(data[field] || '0.0') }), {});
  }

  saveBuildDesignWeight() {
    this.buildDesignWeightService.addBuildDesignWeight(this.form.value)
      .subscribe(response => this.dialogRef.close(response));
  }
}
